module.exports = __webpack_public_path__ + "img/注册背景@2x.178ab2d3.png";